import React, { useState, useEffect } from "react";
import { apiErrors, notify, userDetails } from "../../../../helper";
import { API } from "../../../../config/constants";
import { cloneDeep } from "lodash";
import axiosHelper from "../../../../axiosHelper";
import { useHistory } from "react-router-dom";
import HeaderTitle from "../../../common/HeaderTitle";
import { Col, Container, Label, Row } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import LoaderCustom from "../../../common/LoaderCustom";
import { Drawer } from "@material-ui/core";
import { reactLocalStorage } from "reactjs-localstorage";

const EmpId = userDetails();

const ApprovalWorkFlow = ({ requestId, workflowLevel, employeeCode }) => {

  const formController = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const {
    register,
    setValue,
    reset,
    watch,
    handleSubmit,
    formState: { errors },
    control,
    getValues
  } = formController;

  const history = useHistory();
  const [pageLoader, setPageLoader] = useState(false); // State to manage loading status
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [actionType, setActionType] = useState(""); // State to keep track of the action
  const [annualKYSAndMasterUpdateApprovalDetail, setAnnualKYSAndMasterUpdateApprovalDetail] = useState(null); // State to keep track of the action
  const [formError, setFormError] = useState('');

  useEffect(() => {
    if (!drawerOpen) {
      // setValue("Remark", null)
      reset()
    }
  }, [drawerOpen])

  const onSubmit = async (values, action) => {
    let payload = cloneDeep(values);
    payload.Action = action;
    payload.RequestId = requestId;
    payload.WorkflowLevel = workflowLevel;
    payload.EmployeeId = EmpId?.EmployeeId;

    setPageLoader(true)
    axiosHelper.post(`${API.annualKYSAndMasterUpdateRequestApproveReject}`, payload).then((response) => {
      if (response?.data?.IsSuccessful) {
        notify.success(response?.data?.Data?.Message);
        setPageLoader(false)
        const receiverId = reactLocalStorage.getObject('receiverId');
        const hasValidReceiverId = receiverId !== null && receiverId !== undefined;
        reactLocalStorage.setObject('receiverId', null);
        history.push(hasValidReceiverId ? "/" : "/master-update-requests");
      }
    }).catch((error) => {
      setPageLoader(false)
      if (error.response.status === 401) {
        apiErrors(error)
      } else {
        if (!error?.response?.data?.IsSuccessful) {
          notify.error(error?.response?.data?.ErrorMessage)
        }
      }

    });
  };

  const changeHandler = (e, field) => {
    const value = e.target.value;
    if (value.length <= 500) {
      field.onChange(value);
      setFormError('');
    } else {
      setFormError('Remark cannot exceed 500 characters.');
    }
  };

  const getAnnualKYSAndMasterUpdateApprovalWorkflowDetail = (params) => {
    axiosHelper.get(`${API.GetAnnualKYSAndMasterUpdateApprovalWorkflowDetail}`, {
      params: {
        requestId: params?.requestId,
        employeeId: params?.employeeId,
        workflowlevel: params?.workflowLevel,
        employeeCode: params?.employeeCode
      },
    }).then((response) => {
      if (response?.data?.IsSuccessful) {
        setAnnualKYSAndMasterUpdateApprovalDetail(response?.data?.Data);
      }
    })
      .catch((error) => {
        if (error.response.status === 401) {
          apiErrors(error)
        } 
        // apiErrors(error); // Handle API errors
      });
  }

  useEffect(() => {
    getAnnualKYSAndMasterUpdateApprovalWorkflowDetail({
      requestId,
      workflowLevel,
      employeeId: EmpId?.EmployeeId,
      employeeCode: employeeCode
    });
  }, []);

  const convertISOToUtcDate1 = (isoDate) => {
    const date = new Date(isoDate);
    // Extract date components
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure month is two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure day is two digits
    const year = date.getFullYear();
    // Extract time components
    const hours = String(date.getHours()).padStart(2, "0"); // Ensure hours is two digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Ensure minutes is two digits
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Ensure seconds is two digits
    // Format date as dd/mm/yyyy hh:mm:ss
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <><div className="container-fluid approval-summary-drawer d-flex flex-column pb-5">
      <div className="h-100">
        <Row className="process workflow-row">
          {annualKYSAndMasterUpdateApprovalDetail?.AnnualKYSAndMasterUpdateApprovalDetail?.map(
            (item, index) => (
              <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
                <div
                  className={`card-border ${item.Status === 1
                    ? "card-green"
                    : item.Status === 0
                      ? "card-yellow"
                      : item.Status === 2
                        ? "card-red"
                        : ""}`}
                >
                  <div className="top d-flex">
                    <div className="left text-center">
                      <b>{item.WorkFlowLevel}</b>
                      <span className="d-block">Level</span>
                    </div>
                    <div className="right">
                      <span title={item.EmployeeName}>{item.EmployeeName}</span>
                      <p>{item.ApprovedBy ? item.ApprovedBy : "-"}</p>
                    </div>
                  </div>
                  {/* top */}
                  <div className="bottom">
                    <div className="d-flex mb-1">
                      <span className="small-grey-text left">Date:</span>
                      <span className="right">
                        {new Date(item.ActionTakenDate).toLocaleDateString()}
                      </span>
                    </div>
                    <div className="d-flex">
                      <span className="small-grey-text left">Remark:</span>
                      <span className="right remark-wrapper" title={item.Remark}>
                        {item.Remark ? item.Remark : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          )}
        </Row>
        {/* {annualKYSAndMasterUpdateApprovalDetail?.KYS2ApprovalReviewRequestModel?.map(
          (item, index) => (
            <div key={index}>
              <hr className="hr-seprator mb-4" />
              <h5
                className="card-title ps-1 mt-4 mb-2"
                targetId={index.toString()}
              >{`Review Request ${index + 1}`}</h5>
              <div
                accordionId={index.toString()}
                className="hl-need-form ps-3 hl-request-scroll"
              >
                <div className="review-request pl-0 pt-3">
                  <div className="remarks-wrap">
                    <HeaderTitle title={"Remarks:"} customClass="" />
                    <p className="para-color">{item.ReviewRequestRemark}
                      <strong className="d-block hl-date-remark">
                        {convertISOToUtcDate1(item.ReviewRequestDate)}
                      </strong>
                    </p>
                    <hr className="hr-seprator" />
                  </div>
                  {item.ResponseRemark && (
                    <div className="remarks-wrap ml-4">
                      <HeaderTitle title={"Response:"} customClass="" />
                      <p className="para-color">{item.ResponseRemark}
                        <strong className="d-block hl-date-remark">
                          {convertISOToUtcDate1(item.ResponseDate)}
                        </strong>
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        )} */}
      </div>
      {annualKYSAndMasterUpdateApprovalDetail?.IsButtonVisible && (
        <div className="sf-btn-footer">
          <div className="col-sm-12 bluefooter-butn d-flex align-items-center justify-content-end pb-0">
            <React.Fragment key={""}>
              <button
                type="submit"
                className="approve-button mr5 approve-hover-btn mb-0"
                onClick={() => {
                  setDrawerOpen(true);
                  setActionType("Approved");
                }}
              >
                <div className="save-icon mr-1"></div>
                {"Accept"}
              </button>
              <button
                type={"button"}
                className="mr5 approve-reject-btn mb-0"
                onClick={() => {
                  setDrawerOpen(true);
                  setActionType("Rejected")
                }}
              >
                <div className={"cancel-icon-white mr5"}></div>
                {"Reject"}
              </button>
            </React.Fragment>
          </div>
        </div>
      )}
    </div>
      <Drawer open={drawerOpen} anchor="right" onClose={() => setDrawerOpen(false)} >
        <Container>
          {pageLoader && <LoaderCustom customClass="simulation-Loader" />}
          <div className={"drawer-wrapper w-100 master-summary-drawer"} sx={{ minWidth: "450px" }}>
            <Row className="drawer-heading sticky-top-0">
              <Col>
                <div className={"header-wrapper left"}>
                  <h3>
                    {actionType === "Approved" && "Approve Request"}
                    {actionType === "Rejected" && "Reject Request"}
                  </h3>
                </div>
                <div
                  onClick={() => setDrawerOpen(false)} className={"close-button right"}></div>
              </Col>
            </Row>
            <Row className="part-detail-wrapper pl-3 pr-3 flex-column">
              <Col md="12">
                <form onSubmit={handleSubmit((data) => onSubmit(data, actionType))}>
                  <div className="mb-3">
                    <label className="asterisk-sign text-left">
                      Add Remark<span className="asterisk-required">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="Remark"
                      rules={{ required: 'Remark is required' }}
                      render={({ field }) => (
                        <textarea
                          rows={3}
                          placeholder="Enter"
                          value={field.value}
                          onChange={(e) => changeHandler(e, field)}
                          className="form-control hl-textarea-h"
                          style={{ minWidth: "400px" }}
                        />
                      )}
                    />
                    {errors.Remark && <p className="text-help">{errors.Remark.message}</p>}
                    {formError && <p className="text-help">{formError}</p>}
                  </div >
                  <button type="submit" className="btn btn-primary">Submit</button>
                </form >
              </Col >
            </Row>
          </div>
        </Container>
      </Drawer >
    </>


  );
};
export default ApprovalWorkFlow;
